import type { Locale } from './types';

const zhCNTextMap: Record<string, string> = {
  English: '英语',
  Malay: '马来语',
  Chinese: '中文',
  Mandarin: '华语',
  Tamil: '泰米尔语',
  'Bahasa Malaysia': '马来语',
  Male: '男',
  Female: '女',
  Physical: '线下',
  Online: '线上',
  Both: '两者皆可',
  'In-person': '线下',
  'Online & In-person': '线上与线下',
  'Full Time': '全职',
  'Part Time': '兼职',
  Freelance: '自由职业',
  Homemaker: '家庭主妇/夫',
  Studying: '就学中',
  'Not Currently Employed': '目前未就业',
  Retired: '退休',
  SPM: 'SPM',
  STPM: 'STPM',
  UEC: 'UEC',
  IGCSE: 'IGCSE',
  'A-Level': 'A-Level',
  Foundation: '预科',
  Diploma: '文凭',
  "Bachelor's Degree": '学士学位',
  "Master's Degree": '硕士学位',
  PhD: '博士',
  Others: '其他',
  Other: '其他',
  'National School / SPM': '国民学校 / SPM',
  National: '国民学校',
  'Independent Chinese School / UEC': '华文独中 / UEC',
  CIS: '华文独中',
  'International School': '国际学校',
  International: '国际学校',
  'Standard 1': '小学一年级',
  'Standard 2': '小学二年级',
  'Standard 3': '小学三年级',
  'Standard 4': '小学四年级',
  'Standard 5': '小学五年级',
  'Standard 6': '小学六年级',
  'Form 1': '中一',
  'Form 2': '中二',
  'Form 3': '中三',
  'Form 4': '中四',
  'Form 5': '中五',
  'Form 6': '中六',
  'Year 1': 'Year 1',
  'Year 2': 'Year 2',
  'Year 3': 'Year 3',
  'Year 4': 'Year 4',
  'Year 5': 'Year 5',
  'Year 6': 'Year 6',
  'Year 7': 'Year 7',
  'Year 8': 'Year 8',
  'Year 9': 'Year 9',
  'Year 10': 'Year 10',
  'Year 11': 'Year 11',
  'Less than 1 year': '少于 1 年',
  '1 year': '1 年',
  '2 years': '2 年',
  '3-5 years': '3-5 年',
  '6-10 years': '6-10 年',
  '11-15 years': '11-15 年',
  '16-20 years': '16-20 年',
  '20+ years': '20 年以上',
  Johor: '柔佛',
  Kedah: '吉打',
  Kelantan: '吉兰丹',
  'Kuala Lumpur': '吉隆坡',
  Labuan: '纳闽',
  Malacca: '马六甲',
  'Negeri Sembilan': '森美兰',
  Pahang: '彭亨',
  Penang: '槟城',
  Perak: '霹雳',
  Perlis: '玻璃市',
  Putrajaya: '布城',
  Sabah: '沙巴',
  Sarawak: '砂拉越',
  Selangor: '雪兰莪',
  Terengganu: '登嘉楼',
  'No experience': '无经验',
  'Private Tutor': '私人导师',
  'Current School Teacher': '现职学校老师',
  'Retired School Teacher': '退休学校老师',
  'Part-time Tuition Center Tutor': '补习中心兼职导师',
  'Full-time Tuition Center Tutor': '补习中心全职导师',
  'Kindergarten Teacher': '幼儿园老师',
  Patient: '有耐心',
  Strict: '严格',
  Meticulous: '细心',
  Caring: '关怀型',
  'Explain complex concepts clearly': '能清楚讲解复杂概念',
  'Adapt to different learning styles': '能配合不同学习风格',
  'Create engaging lessons': '能设计有吸引力的课堂',
  'Provide personalized attention': '能提供个别化关注',
  'Break down difficult topics': '能拆解困难课题',
  'Latest exam trends': '熟悉最新考试趋势',
  'Effective study techniques': '了解有效学习技巧',
  'Common student difficulties': '了解学生常见困难',
  'Multiple teaching approaches': '掌握多种教学方法',
  'Bahasa Melayu': '马来文',
  Math: '数学',
  Science: '科学',
  Moral: '道德教育',
  'Islamic Studies': '伊斯兰教育',
  Art: '美术',
  Agriculture: '农业',
  Architecture: '建筑学',
  History: '历史',
  RBT: '设计与工艺',
  Arabic: '阿拉伯语',
  Geography: '地理',
  ASK: '基础电脑科学',
  'Add Math': '高等数学',
  Physics: '物理',
  Chemistry: '化学',
  Biology: '生物',
  Biotechnology: '生物科技',
  'Computer Science': '电脑科学',
  Accounting: '会计',
  'Business Administration': '工商管理',
  Business: '商业',
  Dentistry: '牙医学',
  Education: '教育学',
  Engineering: '工程学',
  'Environmental Science': '环境科学',
  Economics: '经济',
  Finance: '金融学',
  'General Studies': '普通试卷',
  'Information Technology': '信息技术',
  MUET: 'MUET',
  'Math T': '数学 T',
  'Math M': '数学 M',
  'Further Math': '进阶数学',
  ICT: '资讯与通讯科技',
  'Global Perspectives': '全球视野',
  'English/EFL': '英语 / EFL',
  'English/ESL': '英语 / ESL',
  'Coordinated Science': '综合科学',
  Literature: '文学',
  Law: '法律',
  'Art & Design': '艺术与设计',
  'Business Management': '商业管理',
  Marketing: '市场营销',
  Medicine: '医学',
  Music: '音乐',
  Nursing: '护理学',
  Pharmacy: '药剂学',
  Philosophy: '哲学',
  'Physical Education': '体育教育',
  'Political Science': '政治学',
  Psychology: '心理学',
  Sociology: '社会学',
  'Veterinary Science': '兽医学',
  Mathematics: '数学',
  'English Language': '英语',
  'English Literature': '英国文学',
  'Additional Mathematics': '高等数学',
  'Combined Science': '综合科学',
  'Business Studies': '商业学',
  'Prinsip Perakaunan': '会计原理',
  Ekonomi: '经济',
  Perniagaan: '商业',
  Sejarah: '历史',
  'Pendidikan Moral': '道德教育',
  'Pendidikan Islam': '伊斯兰教育',
  'Pendidikan Jasmani dan Kesihatan': '体育与健康教育',
  'Seni Visual': '视觉艺术',
  Muzik: '音乐',
  'Bahasa Cina': '华文',
  'Bahasa Tamil': '淡米尔文',
  'Bahasa Arab': '阿拉伯文',
  'Bahasa Iban': '伊班文',
  'Bahasa Kadazandusun': '卡达山杜顺文',
  'O-Level': 'O-Level',
  Matriculation: '大学预科',
  'Primary School': '小学',
  'Secondary School': '中学',
  'Pre-University': '大学预科',
  'Standard 1 - Standard 3': '小学一年级至三年级',
  'Standard 4 - Standard 6': '小学四年级至六年级',
  'Form 1 - Form 3': '中一至中三',
  'Form 4 - Form 5': '中四至中五',
  'High School Graduate': '高中毕业',
  '0-1 years': '0-1 年',
  '1-3 years': '1-3 年',
  '5-10 years': '5-10 年',
  '10+ years': '10 年以上',
  'Associate Degree': '副学士',
  'Professional Certificate': '专业证书',
  'Use "{value}" as custom input': '使用 “{value}” 作为自定义输入',
  'No options found': '没有可用选项',
  'No options available': '没有可用选项',
  'No results': '没有结果',
  Search: '搜索',
  'Search...': '搜索...',
  'Type to search': '输入以搜索',
  'Type to search or enter custom value': '输入以搜索或填写自定义内容',
  'Clear input': '清除输入',
  'Select an option...': '请选择...',
  'Select options...': '请选择...',
  item: '项',
  items: '项',
  selected: '已选择',
  more: '更多',
  'Search or type...': '搜索或输入...',
  'No matching results found': '没有匹配结果',
  'Under review': '审核中',
  'New': '新个案',
  Pending: '处理中',
  'Action needed': '需要处理',
  'Awaiting payment': '等待付款',
  Rejected: '已拒绝',
  Closed: '已关闭',
  Open: '进行中',
  Matched: '已配对',
  Applied: '已申请',
  Recommended: '推荐',
  'Awaiting your response': '等待你的回应',
  'Accepted by you': '你已接受',
  'Not selected': '未被选中',
  'Declined by you': '你已拒绝',
  'No longer available': '已不可申请',
  'Action needed.': '需要处理。',
  'Loading...': '加载中...',
  'Go Back': '返回',
  'Back to Home': '返回首页',
  'Browse Cases': '浏览个案',
  'Browse Tutors': '浏览导师',
  Cancel: '取消',
  Delete: '删除',
  'Try Again': '重试',
  'Retrying...': '重试中...',
  'View Profile': '查看资料',
  'Manage linked cases': '管理关联个案',
  'Saving changes': '正在保存',
  Unavailable: '不可用',
  Updated: '更新于',
  Languages: '语言',
  Location: '地点',
  'Location not set': '未设置地点',
  'Linked cases': '关联个案',
  'profile complete': '资料完成',
  TBD: '待定',
  'No changes': '没有更改',
  'Save cases': '保存个案',
  'Saving…': '保存中…',
  'Loading your cases…': '正在加载你的个案…',
  'Could not load your cases': '无法加载你的个案',
  'Please retry without closing this window.': '请在不关闭此窗口的情况下重试。',
  'Try again': '重试',
  'Post a case first': '请先发布个案',
  'Class Details': '个案详情',
  'Unable to load case details.': '无法加载个案详情。',
  'Withdraw Application': '撤回申请',
  Withdraw: '撤回',
  'Accept Recommended Case': '接受推荐个案',
  'Reject Recommended Case': '拒绝推荐个案',
  'Yes, Accept': '确认接受',
  'Yes, Reject': '确认拒绝',
  'Safe & Secure': '安全可靠',
  'Only tutors can apply for classes.': '只有导师可以申请课程。',
  'Please log in to apply for this class.': '请先登录以申请此课程。',
  'Apply for This Class': '申请此课程',
  'View Tutor Profile': '查看导师资料',
  'Parent Name': '家长姓名',
  Nationality: '国籍',
  'Parent Information': '家长资料',
  'Additional Remarks': '补充说明',
  'No additional remarks provided': '暂无补充说明',
  'Class Information': '课程资料',
  Frequency: '频率',
  'Preferred Times': '首选时段',
  Flexible: '可灵活安排',
  'Teaching Method': '授课方式',
  'Face-to-face at student\'s location in {value}': '在 {value} 学生地点面授',
  'Online via video conferencing (Zoom, Google Meet, etc.)': '通过线上会议软件授课（如 Zoom、Google Meet 等）',
  'Case Status': '个案状态',
  'Current status': '当前状态',
  'Shortlisted tutors': '已 shortlist 导师',
  'Matched tutor': '已配对导师',
  Confirmed: '已确认',
  'Not yet': '尚未',
  'What happens next?': '接下来会怎样？',
  Rate: '时薪',
  Experience: '经验',
  Subjects: '科目',
  'Cannot apply yet': '暂时不能申请',
  'Must be verified by admin': '必须先通过管理员审核',
  'Access Denied': '无法访问',
  'Only parents can access this page.': '只有家长可以访问此页面。',
  'Only tutors can access this page.': '只有导师可以访问此页面。',
  'My Cases': '我的个案',
  'Your Cases': '你的个案',
  'Post New Case': '发布新个案',
  'All Cases': '全部个案',
  'Under Review': '审核中',
  'In Progress': '处理中',
  'Error loading cases': '加载个案时出错',
  'An error occurred': '发生错误',
  'No cases yet': '还没有个案',
  'No cases under review': '没有审核中的个案',
  'No cases currently matching': '没有正在配对中的个案',
  'No cases in progress': '没有进行中的个案',
  'No rejected cases': '没有被拒绝的个案',
  'Delete Case': '删除个案',
  'Confirm Delete': '确认删除',
  'Deleting...': '删除中...',
  'My Liked Tutors': '我收藏的导师',
  'Your favorite tutors all in one place': '你收藏的导师都在这里',
  'No liked tutors yet': '还没有收藏的导师',
  'No Liked Tutors Yet': '还没有收藏导师',
  'Sign In Required': '需要登录',
  'Sign In': '登录',
  'Parent Only': '仅限家长',
  'Complete Your Profile': '完成你的资料',
  'Upload required documents for verification': '上传所需文件以进行审核',
  'Document Verification': '文件审核',
  'Already uploaded': '已上传',
  Remove: '移除',
  'Click to upload or drag and drop': '点击上传或拖放文件',
  'Support Documents': '辅助文件',
  'Uploaded support documents': '已上传的辅助文件',
  'Not provided': '未提供',
  'Phone number is required': '请输入电话号码',
  'Invalid phone number format': '电话号码格式无效',
  'Please enter a valid phone number': '请输入有效的电话号码',
  'Previous decade': '上一个十年',
  'Next decade': '下一个十年',
  'Past Public Exam Results': '过往公开考试成绩',
  "(It's required, but you can skip it for now)": '（这是必填项，但你现在可以先跳过）',
  'Add Exam Result': '添加考试成绩',
  'No exam results added yet': '尚未添加考试成绩',
  'Required, can add later': '必填，可稍后补充',
  'Select Exam Type': '选择考试类型',
  'Exam Type': '考试类型',
  'Select exam type': '选择考试类型',
  Year: '年份',
  'Add Subjects': '添加科目',
  'Search and select a subject...': '搜索并选择科目...',
  'Subject Grades': '科目成绩',
  'Enter grade (e.g. A+, 90, Distinction)': '输入成绩（例如 A+、90、Distinction）',
  'Select Grade': '选择成绩',
  'Tutor Profile': '导师资料',
  Verified: '已认证',
  'Experience not specified': '未填写经验',
  'Starting from': '起始价格',
  hr: '小时',
  'of experience': '经验',
  'Edit Profile': '编辑资料',
  'Update your tutor profile information': '更新你的导师资料',
  'Pending Verification': '等待审核',
  "Your profile is currently under review by our team. This typically takes 2-3 business days. You can continue editing your profile while it's being reviewed.": '你的资料目前正在由团队审核，通常需要 2 至 3 个工作日。审核期间你仍可继续编辑资料。',
  'Verification Rejected': '审核未通过',
  'Please update your profile based on the reason above and resubmit for review.': '请根据以上原因更新你的资料后重新提交审核。',
  'Verified Profile Locked': '已认证资料受限',
  'Your profile has been verified. Only your subjects and levels can still be updated here.': '你的资料已通过审核，目前这里只能更新授课科目与年级。',
  'We recently updated the subject options, so verified tutors can now adjust their teaching subjects and education levels here when needed.': '我们最近更新了科目选项，因此已认证导师现在可在这里按需要调整授课科目和教育阶段。',
  'Profile photo changes are saved immediately after upload. For any other profile changes, please contact customer service.': '头像上传后会立即保存。如需修改其他资料，请联系客服。',
  'Profile Photo': '头像照片',
  'JPG, PNG or WebP · max 5 MB': 'JPG、PNG 或 WebP · 最大 5 MB',
  'Change photo': '更换照片',
  'Profile photo updated!': '头像已更新！',
  'Failed to upload photo. Please try again.': '上传头像失败，请重试。',
  'Edit your basic personal information': '编辑你的基本个人资料',
  'Update your personal information': '更新你的个人资料',
  'Full Name': '姓名',
  'Enter your full name': '输入你的姓名',
  'Phone Number': '电话号码',
  'Enter your phone number': '输入你的电话号码',
  'Date of Birth': '出生日期',
  Gender: '性别',
  'Select your gender': '选择你的性别',
  'Search and select your nationality': '搜索并选择你的国籍',
  'Select tuition types you offer': '选择你可提供的授课方式',
  'Select all the types of tuition you can provide': '请选择你可以提供的所有授课方式',
  'Physical Tuition': '线下授课',
  'Online Tuition': '线上授课',
  'Selected': '已选择',
  'Select your preferred teaching areas': '选择你偏好的授课地区',
  'Select your preferred teaching state and districts': '选择你偏好的授课州属与地区',
  State: '州属',
  'Select a state...': '选择州属...',
  'Preferred Districts (Select multiple)': '偏好地区（可多选）',
  'Select districts...': '选择地区...',
  'Specific Areas / Neighbourhoods': '具体区域 / 社区',
  Optional: '可选',
  'e.g. Taman Desa, Bangsar Baru, Sri Petaling...': '例如：Taman Desa、Bangsar Baru、Sri Petaling...',
  Add: '添加',
  'Select subjects you teach by education level': '按教育阶段选择你授课的科目',
  'Education System': '教育体系',
  'Select education system': '选择教育体系',
  'Education Level(s)': '教育阶段',
  'Select education level(s)': '选择教育阶段',
  'Select subjects': '选择科目',
  'Add Subject': '添加科目',
  'Enter your education information': '填写你的学历资料',
  'Current Status': '目前状态',
  'Highest Education Level': '最高学历',
  'Please specify': '请注明',
  'Enter your education level': '输入你的学历',
  'Current Studying University / School': '目前就读大学 / 学校',
  School: '学校',
  'Search for a university or enter manually...': '搜索大学或手动输入...',
  'Major of Study': '主修科目',
  'Search for a field of study or enter manually...': '搜索主修领域或手动输入...',
  'Set your teaching availability': '设置你的授课时间',
  'Set your hourly rate': '设置你的时薪',
  'Hourly Rate (MYR)': '时薪（MYR）',
  'Tell us about your tutoring experience': '告诉我们你的教学经验',
  'Years of Experience': '教学年资',
  'Select years': '选择年资',
  'Types of Experience': '经验类型',
  'Select all that apply:': '请选择所有适用项：',
  'School / Teaching Institution': '学校 / 教学机构',
  optional: '可选',
  'Sharing the school or institution where you teach can significantly improve your expected hourly rate and selection chances.': '填写你任教的学校或机构，有助于提升预期时薪与被选中的机会。',
  'e.g. SMK Taman Desa, ABC Kindergarten': '例如：SMK Taman Desa、ABC Kindergarten',
  'Enter your public exam results': '填写你的公开考试成绩',
  'Select your teaching styles': '选择你的教学风格',
  'Your Teaching Style': '你的教学风格',
  'Others (Optional)': '其他（可选）',
  'Add any other teaching characteristics...': '补充其他教学特点...',
  'Write about yourself': '介绍你自己',
  'Tell us about yourself, your teaching philosophy, and experience...': '介绍你自己、你的教学理念与经验...',
  'Please fix your subjects and levels before saving.': '请先修正科目与年级的内容再保存。',
  'Please fix all errors before saving': '请先修正所有错误后再保存。',
  'Subjects and levels updated successfully!': '科目与年级已成功更新！',
  'Profile updated! Your profile has been resubmitted for verification.': '资料已更新，并已重新提交审核。',
  'Profile updated successfully!': '资料更新成功！',
  'Failed to update profile. Please try again.': '更新资料失败，请重试。',
  'Save Subjects & Levels': '保存科目与年级',
  'Save Changes': '保存更改',
  Save: '保存',
  'Tuition Details': '授课详情',
  'Type of Tuition': '授课方式',
  'Tuition Type': '授课方式',
  'Teaching Preferences': '授课偏好',
  'Subjects by Level': '按年级选择科目',
  'Personal Profile': '个人资料',
  'Hourly Rate & Languages': '时薪与授课语言',
  'Tutor Experience & Exam': '教学经验与考试成绩',
  'Teaching Style & About Me': '教学风格与自我介绍',
  'Tutor Registration': '导师注册',
  'Post a Tuition Case': '发布补习个案',
  'Teaching Languages': '授课语言',
  'Languages You Can Teach In': '你可使用的授课语言',
  'Select Education System': '选择教育体系',
  'Education Level': '教育阶段',
  'Select Level': '选择阶段',
  'Location & Preferred Time': '地点与偏好时间',
  'Select State': '选择州属',
  District: '地区',
  'Select a district...': '选择地区...',
  'Specific Area / Neighbourhood': '具体区域 / 社区',
  'e.g. Taman Desa, Bangsar Baru, Sri Hartamas...': '例如：Taman Desa、Bangsar Baru、Sri Hartamas...',
  'Available Times': '可上课时间',
  'Preferred Teaching Time': '偏好授课时间',
  'Preferred Teaching Times': '偏好授课时间',
  'Click on the grid to select your preferred times': '点击表格选择你偏好的时间',
  "Click on the grid to select when you're available to teach": '点击表格选择你可授课的时间',
  'Subject & Duration': '科目与时长',
  Subject: '科目',
  'Select Subject': '选择科目',
  'Please select a level first': '请先选择阶段',
  'Select languages...': '选择语言...',
  'Lessons per Week': '每周上课次数',
  '1 lesson/week': '每周 1 课',
  '2 lessons/week': '每周 2 课',
  '3 lessons/week': '每周 3 课',
  '4 lessons/week': '每周 4 课',
  '5 lessons/week': '每周 5 课',
  Select: '选择',
  'Duration per Lesson': '每节课时长',
  '1 hour': '1 小时',
  '1.5 hours': '1.5 小时',
  '2 hours': '2 小时',
  '2.5 hours': '2.5 小时',
  '3 hours': '3 小时',
  'Additional Remarks/Requirements': '补充备注 / 要求',
  "E.g., student's current level, specific topics to focus on, preferred tutor characteristics...": '例如：学生目前程度、想重点加强的课题、偏好的导师特质...',
  Budget: '预算',
  'Set your maximum hourly rate budget for this tuition case. This helps tutors understand your budget expectations.': '为这则补习个案设置你可接受的最高时薪预算，这能帮助导师更了解你的预算预期。',
  'Maximum Hourly Rate': '最高时薪',
  'View Rate Reference': '查看收费参考',
  'Tip:': '提示：',
  'Setting a competitive hourly rate increases the chances of finding qualified tutors quickly.': '设置有竞争力的时薪，有助于更快找到合适的导师。',
  'I agree to the': '我同意',
  'Terms of Service': '服务条款',
  and: '及',
  'Privacy Policy': '隐私政策',
  '. I confirm that all information provided is accurate and truthful.': '，并确认我提供的所有资料均准确属实。',
  Previous: '上一步',
  Next: '下一步',
  'Submit Case': '提交个案',
  'Submit Registration': '提交注册',
  'Submitting...': '提交中...',
  'Unsaved Changes': '尚未保存的更改',
  'You have unsaved changes in your form. Are you sure you want to discard them?': '你的表单尚有未保存的更改，确定要放弃吗？',
  'You have unsaved changes in your registration. Are you sure you want to discard them?': '你的注册资料尚有未保存的更改，确定要放弃吗？',
  'Continue Editing': '继续编辑',
  Discard: '放弃',
  'You are currently logged in as a tutor. Please switch to a parent account before submitting a tuition case.': '你目前登录的是导师账号。提交补习个案前，请先切换到家长账号。',
  'You are currently logged in as a parent. Please switch to a tutor account before submitting your tutor profile.': '你目前登录的是家长账号。提交导师资料前，请先切换到导师账号。',
  'Please accept the Terms of Service and Privacy Policy to proceed': '请先同意服务条款与隐私政策后再继续',
  'Tuition case created successfully!': '补习个案创建成功！',
  'Please complete all required fields correctly': '请正确填写所有必填字段',
  'Failed to create case: {value}': '创建个案失败：{value}',
  'Please complete the highlighted profile sections before submitting.': '请先完成高亮标示的资料部分后再提交。',
  'Please fix the errors in Step 7 before submitting': '提交前请先修正第 7 步的错误',
  'Tutor profile updated successfully!': '导师资料更新成功！',
  'Complete the missing sections to finish your tutor profile.': '请完成缺少的部分，以完成你的导师资料。',
  'We brought you to the first missing item and highlighted what still needs attention.': '我们已带你前往第一个缺少的项目，并高亮显示仍需补充的内容。',
  'School / University': '学校 / 大学',
  'Search for a school or university...': '搜索学校或大学...',
  'Enter custom school or university name...': '输入自定义学校或大学名称...',
  'Add Custom School/University': '添加自定义学校 / 大学',
  'Enter custom major of study...': '输入自定义主修科目...',
  'Add Custom Major': '添加自定义主修科目',
  'Hourly Teaching Rate': '每小时授课费',
  'Tutor Experience': '教学经验',
  'Experience Types': '经验类型',
  'Select years of experience': '选择教学年资',
  'Subjects You Can Teach': '你可教授的科目',
  'e.g., French, German, Japanese, Korean...': '例如：法语、德语、日语、韩语……',
  'About Me': '自我介绍',
  'Tell us about yourself': '介绍一下你自己',
  "Tutors who complete this section are more likely to be selected by parents. If you don't have time now, you can fill this in later.": '完成这部分内容的导师更容易被家长选中。如果你现在没有时间，也可以之后再填写。',
  'Say something you want others to know more about you!': '写一些让别人更了解你的内容吧！',
  'Minimum 20 words if filled': '如填写，至少 20 个词',
  'Terms & Conditions': '条款与条件',
  'Step {current} of {total} — {title}': '第 {current} 步，共 {total} 步 — {title}',
  Monday: '周一',
  Tuesday: '周二',
  Wednesday: '周三',
  Thursday: '周四',
  Friday: '周五',
  Saturday: '周六',
  Sunday: '周日',
  Morning: '早上',
  Afternoon: '下午',
  Evening: '晚上',
  'Set {slot} Time Range': '设置{slot}时段',
  'Scroll to select start and end times for {slot}': '滚动选择{slot}的开始与结束时间',
  'Start Time': '开始时间',
  'End Time': '结束时间',
};

export function localizeText(locale: Locale, text: string): string {
  if (locale === 'en') {
    return text;
  }

  return zhCNTextMap[text] ?? text;
}

export function localizeTemplate(locale: Locale, template: string, value: string): string {
  const localizedTemplate = localizeText(locale, template);
  return localizedTemplate.replace('{value}', value);
}

export function localizeOptions<T extends { label: string }>(locale: Locale, options: T[]): T[] {
  return options.map((option) => ({
    ...option,
    label: localizeText(locale, option.label),
  }));
}

export function localizeStringOptions(locale: Locale, options: string[]) {
  return options.map((option) => ({
    value: option,
    label: localizeText(locale, option),
  }));
}

export function localizeStringList(locale: Locale, values: string[]) {
  return values.map((value) => localizeText(locale, value));
}

export function localizeGroupedStringRecord(
  locale: Locale,
  groups: Record<string, string[]>
): Record<string, string[]> {
  return Object.fromEntries(
    Object.entries(groups).map(([key, values]) => [localizeText(locale, key), localizeStringList(locale, values)])
  );
}
